export const PROMO_DURATIONS = ['once', 'repeating', 'forever'];

export function promoDurationLabel(promo) {
  if (promo.duration === 'once') return 'Once';
  if (promo.duration === 'forever') return 'Forever';
  if (promo.duration === 'repeating' && Number.isSafeInteger(promo.durationInMonths) && promo.durationInMonths > 0) {
    return `${promo.durationInMonths} calendar month${promo.durationInMonths === 1 ? '' : 's'}`;
  }
  return 'Duration unavailable';
}

export function localDateTime(value) {
  if (!value) return '';
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
}

export function promoEditForm(promo) {
  return {
    code: promo.code || '',
    description: promo.description || '',
    discountType: promo.discountType || '',
    discountValue: String(promo.discountValue ?? ''),
    duration: PROMO_DURATIONS.includes(promo.duration) ? promo.duration : '',
    durationInMonths: String(promo.durationInMonths ?? ''),
    appliesTo: promo.appliesTo || [],
    maxRedemptions: String(promo.maxRedemptions ?? ''),
    maxRedemptionsPerUser: String(promo.maxRedemptionsPerUser ?? ''),
    expiresAt: localDateTime(promo.expiresAt),
  };
}

export function promoPayload(form, original) {
  const payload = {
    description: form.description.trim(),
    discountType: form.discountType,
    discountValue: Number(form.discountValue),
    duration: form.duration,
    durationInMonths: form.duration === 'repeating' ? Number(form.durationInMonths) : null,
    appliesTo: form.appliesTo,
    maxRedemptions: form.maxRedemptions ? Number(form.maxRedemptions) : null,
    maxRedemptionsPerUser: Number(form.maxRedemptionsPerUser),
    expiresAt: form.expiresAt ? new Date(form.expiresAt).toISOString() : null,
  };
  if (!original) return { code: form.code.trim().toUpperCase(), ...payload };

  // Omit untouched fields so an offer edit cannot reset usage limits or expiry.
  const initial = promoEditForm(original);
  const patch = {};
  Object.keys(payload).forEach((key) => {
    if (JSON.stringify(form[key]) !== JSON.stringify(initial[key])) patch[key] = payload[key];
  });
  // Duration and months form one contract, including explicit null for once/forever.
  if ('duration' in patch || 'durationInMonths' in patch) {
    patch.duration = payload.duration;
    patch.durationInMonths = payload.durationInMonths;
  }
  return patch;
}

export function promoFieldMatches(key, stored, expected) {
  if (key === 'expiresAt' && stored && expected) return new Date(stored).getTime() === new Date(expected).getTime();
  if (Array.isArray(expected)) return Array.isArray(stored) && JSON.stringify([...stored].sort()) === JSON.stringify([...expected].sort());
  // An empty optional description may be omitted by the server.
  if (key === 'description' && expected === '') return stored == null || stored === '';
  return stored === expected;
}
